/*
  QBounce community map (snippets/qb-map.liquid): region chips and pins spotlight a region and show its countries;
  regions take turns every 3.2 s while the map is on screen, until the shopper picks one (not with reduced motion).
  Arrow keys move between the chips. The map tilts back a little once it scrolls into view (CSS, .is-seen).
*/
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.qbReady) return;
    root.dataset.qbReady = '1';
    var chips = Array.prototype.slice.call(root.querySelectorAll('.qb-map__chip'));
    var pins = Array.prototype.slice.call(root.querySelectorAll('.qb-map__pin'));
    var infos = Array.prototype.slice.call(root.querySelectorAll('.qb-map__info-item'));
    var plane = root.querySelector('.qb-map__plane');
    if (!chips.length || !plane) return;
    var cur = 0, timer = null, picked = false, visible = false, hover = false;

    function show(i) {
      cur = i;
      chips.forEach(function (c) { c.setAttribute('aria-pressed', String(Number(c.dataset.i) === i)); });
      pins.forEach(function (p) { p.classList.toggle('is-on', Number(p.dataset.i) === i); });
      infos.forEach(function (x) { x.classList.toggle('is-on', Number(x.dataset.i) === i); });
      var pin = pins.filter(function (p) { return Number(p.dataset.i) === i; })[0];
      if (pin) {
        plane.style.setProperty('--sx', pin.style.getPropertyValue('--x'));
        plane.style.setProperty('--sy', pin.style.getPropertyValue('--y'));
      }
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      if (reduce || picked || timer || !visible || hover) return;
      timer = setInterval(function () { show((cur + 1) % chips.length); }, 3200);
    }
    function pick(i) { picked = true; stop(); show(i); }

    chips.forEach(function (c) { c.addEventListener('click', function () { pick(Number(c.dataset.i)); }); });
    pins.forEach(function (p) { p.addEventListener('click', function () { pick(Number(p.dataset.i)); }); });
    root.querySelector('.qb-map__chips').addEventListener('keydown', function (e) {
      var k = e.key;
      if (k !== 'ArrowRight' && k !== 'ArrowLeft' && k !== 'Home' && k !== 'End') return;
      e.preventDefault();
      var i = chips.indexOf(document.activeElement);
      if (i < 0) i = cur;
      if (k === 'ArrowRight') i = (i + 1) % chips.length;
      else if (k === 'ArrowLeft') i = (i - 1 + chips.length) % chips.length;
      else if (k === 'Home') i = 0;
      else i = chips.length - 1;
      chips[i].focus();
      pick(i);
    });
    root.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hover = true; stop(); } });
    root.addEventListener('pointerleave', function () { hover = false; start(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          visible = en.isIntersecting;
          root.classList.toggle('is-visible', visible);
          if (visible) root.classList.add('is-seen');
          if (visible) start(); else stop();
        });
      }, { threshold: 0.3 }).observe(root);
    } else {
      root.classList.add('is-seen', 'is-visible');
    }
    show(0);
  }

  function all() { document.querySelectorAll('[data-qb-map]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
})();
